import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { useGlobalContext } from "../context/appContext";
import Loader from "./Loader";
import Followers from "./SellerComponents/Followers";
import Following from "./SellerComponents/Following";

const Seller = () => {
  const { id } = useParams();
  const { isLoading, fetchSingleSeller, seller } = useGlobalContext();
  // Default seller's values
  const [values, setValues] = useState({
    name: "",
    lastname: "",
    username: "",
    created: [],
    followers: [],
    following: [],
  });
  const [showFollowers, setShowFollowers] = useState(false);
  const [showFollowing, setShowFollowing] = useState(false);

  useEffect(() => {
    fetchSingleSeller(id);
  }, [id]);

  useEffect(() => {
    if (seller) {
      // Set seller's values using the ones coming from GlobalContext
      const { name, lastname, username, created, followers, following } =
        seller;
      setValues({ name, lastname, username, created, followers, following });
    }
  }, [seller]);

  if (isLoading && !seller) {
    return <Loader />;
  }

  if (!seller) {
    return (
      <>
        <h5>There was an error, please double check the seller's ID</h5>
      </>
    );
  }

  return (
    <div className="flex h-auto items-center justify-center">
      <div className="mt-14 md:mt-20 flex flex-col items-center h-auto w-4/5">
        {/* Seller Info */}
        <img
          className="w-24 rounded-lg mb-2"
          src="http://romanroadtrust.co.uk/wp-content/uploads/2018/01/profile-icon-png-898.png"
          alt=""
        />
        <h1 className="text-xl font-bold">{`${values.name} ${values.lastname}`}</h1>
        <p className="text-gray-400">@{values.username}</p>

        {/* Created|Following|Followers layout*/}
        <div className="mt-10 flex items-center shadow rounded-lg justify-around">
          <div
            style={{ backgroundColor: "#1F51FF" }}
            className="text-center text-white w-28 shadow cursor-pointer p-2 rounded-l-lg"
          >
            <p className="font-medium">{values.created.length}</p>
            <p className="font-medium">Created</p>
          </div>

          <div
            onClick={() => {
              setShowFollowing(!showFollowing);
            }}
            className="text-center w-28 bg-white cursor-pointer border-r-2 p-2"
          >
            <p>{values.following.length}</p>
            <p className="font-medium text-gray-800">Following</p>
          </div>

          <div
            onClick={() => {
              setShowFollowers(!showFollowers);
            }}
            className="text-center w-28 bg-white cursor-pointer p-2 rounded-r-lg"
          >
            <p>{values.followers.length}</p>
            <p className="font-medium text-gray-800">Followers</p>
          </div>
        </div>

        {/* Followers and Following buttons*/}
        <Followers
          followers={values.followers}
          setShowFollowers={setShowFollowers}
          showFollowers={showFollowers}
        />
        <Following
          following={values.following}
          showFollowing={showFollowing}
          closeFollowing={() => setShowFollowing(false)}
        />

        {/* Array of NFTs created by seller*/}
        <div style={{ maxWidth: "1300px" }} className="pl-2 w-full mt-10">
          <h1 className="text-lg font-medium text-gray-600">NFTs Created</h1>
        </div>
        <div
          style={{ maxWidth: "1300px" }}
          className="flex flex-wrap justify-around items-center w-full"
        >
          {values.created.map((nft) => (
            <Link key={nft.id} to={`/nft/${nft.id}`}>
              <img src={nft.img} className="m-2 rounded-lg h-64 w-64" alt="" />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Seller;
